import {CAMPAIGN_FETCHED} from '../actions/campaign';

export default function campaign(state = {}, action) {
    switch (action.type) {
        case CAMPAIGN_FETCHED:
            return action.payload;
        default:
            return state;
    }
}